// Message Templates API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { TEMPLATES } = API_ENDPOINTS;

export const templatesApi = {
  /** GET /admin/templates/ — all templates (active + inactive, full fields) */
  getList: () => axiosInstance.get(TEMPLATES.LIST),

  /** POST /admin/templates/ — { title, message } */
  create: (data) => axiosInstance.post(TEMPLATES.LIST, data),

  /** PATCH /admin/templates/<id>/ — send only the keys you want to update ({ is_active: false } hides it) */
  update: (id, data) => axiosInstance.patch(TEMPLATES.DETAIL(id), data),

  /** DELETE /admin/templates/<id>/ — permanent removal */
  remove: (id) => axiosInstance.delete(TEMPLATES.DETAIL(id)),
};
